import { render, staticRenderFns } from "./areasManage.vue?vue&type=template&id=0c333eb0&scoped=true"
import script from "./areasManage.vue?vue&type=script&lang=js"
export * from "./areasManage.vue?vue&type=script&lang=js"
import style0 from "./areasManage.vue?vue&type=style&index=0&id=0c333eb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c333eb0",
  null
  
)

export default component.exports